import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import DesktopLayout from '../components/layout/DesktopLayout';
import './NotFoundPage.css';

/**
 * 404 Not Found Page
 * 顯示找不到頁面的提示，並在 2 秒後自動導向首頁
 */
const NotFoundPage = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(2);
  const navigateRequested = useRef(false);

  useEffect(() => {
    // Prevent navigation if already requested
    if (navigateRequested.current) return;

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigateRequested.current = true;
          // Schedule navigation after the current render cycle
          setTimeout(() => navigate('/'), 0);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="not-found-page">
      <DesktopLayout>
        <div className="not-found-page__container">
          <div className="not-found-page__content">
            <h1 className="not-found-page__code">404</h1>
            <h2 className="not-found-page__title">找不到頁面</h2>
            <p className="not-found-page__message">
              抱歉，您尋找的頁面不存在。
            </p>
            <p className="not-found-page__countdown">
              將在 <span className="not-found-page__countdown-number">{countdown}</span> 秒後自動返回首頁...
            </p>
            <button
              className="btn btn--primary btn--large"
              onClick={() => navigate('/')}
            >
              立即返回首頁
            </button>
          </div>
        </div>
      </DesktopLayout>
    </div>
  );
};

export default NotFoundPage;
